import dayjs from "dayjs";
import isoWeek from "dayjs/plugin/isoWeek";
import { FC, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { MazakaSelect } from "./MazakaSelect";
import { MazakaRangePicker } from "./MazakaRangePicker";
import { Col, FormInstance, Row, Typography } from "antd";

dayjs.extend(isoWeek);



interface GeneralTimePeriodsSelectProps {
  xs?: number;
  md?: number;
  sm?: number;
  lg?: number;
  xl?: number;
  filter: any;
  className?: string;
  size?:any,
  actionFunc: any;
  dateOptions:any,
  form:FormInstance
  isMobile?:boolean
}

const GeneralTimePeriodsSelect: FC<GeneralTimePeriodsSelectProps> = (props) => {
  const [isShowCustomDate,setIsShowCustomDate] = useState(false)
  const dateOptions: Record<
    string,
    { label: string; value: string; OrderDateMin: string; OrderDateMax: string }
  > = {
    Today: {
      label: "Bugün",
      value: "Today",
      OrderDateMin: dayjs().format("YYYY-MM-DD"),
      OrderDateMax: dayjs().format("YYYY-MM-DD"),
    },
    Yesterday: {
      label: "Dün",
      value: "Yesterday",
      OrderDateMin: dayjs().subtract(1, "day").format("YYYY-MM-DD"),
      OrderDateMax: dayjs().format("YYYY-MM-DD"),
    },
    ThisWeek: {
      label: "Bu Hafta",
      value: "ThisWeek",
      OrderDateMin: dayjs().startOf("isoWeek").format("YYYY-MM-DD"),
      OrderDateMax: dayjs().format("YYYY-MM-DD"),
    },
    LastSevenDays: {
      label: "Son 7 Gün",
      value: "LastSevenDays",
      OrderDateMin: dayjs().subtract(7, "day").format("YYYY-MM-DD"),
      OrderDateMax: dayjs().format("YYYY-MM-DD"),
    },
    LastFifteenDays: {
      label: "Son 15 Gün",
      value: "LastFifteenDays",
      OrderDateMin: dayjs().subtract(15, "day").format("YYYY-MM-DD"),
      OrderDateMax: dayjs().format("YYYY-MM-DD"),
    },
    ThisMonth: {
      label: "Bu Ay",
      value: "ThisMonth",
      OrderDateMin: dayjs().startOf("month").format("YYYY-MM-DD"),
      OrderDateMax: dayjs().format("YYYY-MM-DD"),
    },
    LastThirtyDays: {
      label: "Son 30 Gün",
      value: "LastThirtyDays",
      OrderDateMin: dayjs().subtract(30, "day").format("YYYY-MM-DD"),
      OrderDateMax: dayjs().format("YYYY-MM-DD"),
    },
    LastMonth: {
      label: "Geçen Ay",
      value: "LastMonth",
      OrderDateMin: dayjs()
        .subtract(1, "month")
        .startOf("month")
        .format("YYYY-MM-DD"),
      OrderDateMax: dayjs()
        .subtract(1, "month")
        .endOf("month")
        .format("YYYY-MM-DD"),
    },
    ThisYear: {
      label: "Bu Yıl",
      value: "ThisYear",
      OrderDateMin: dayjs().startOf("year").format("YYYY-MM-DD"),
      OrderDateMax: dayjs().format("YYYY-MM-DD"),
    },
    LastYear: {
      label: "Geçen Yıl",
      value: "LastYear",
      OrderDateMin: dayjs()
        .subtract(1, "year")
        .startOf("year")
        .format("YYYY-MM-DD"),
      OrderDateMax: dayjs()
        .subtract(1, "year")
        .endOf("year")
        .format("YYYY-MM-DD"),
    },
    Custom: {
      label: "Özel Tarih Aralığı",
      value: "Custom",
      OrderDateMin: "",
      OrderDateMax: "",
    },
  };


  const [selectedDateOption, setSelectedDateOption] = useState<
    string | undefined
  >(undefined);
  const dispatch = useDispatch();
  const {Text} = Typography

  useEffect(() => {
    if (!props.filter.OrderDateMin && !props.filter.OrderDateMax) {
      setSelectedDateOption(undefined);
    }
  }, [props.filter]);

  const handleDateFilterChange = (value: string) => {
    setSelectedDateOption(value);
  
    if (value === "Custom") {
      setIsShowCustomDate(true);
    } else {
      setIsShowCustomDate(false);
  
      if (dateOptions[value]) {
        let currentFilter = {
          ...props.filter,
          StartDate: dateOptions[value].OrderDateMin,
          EndDate: dateOptions[value].OrderDateMax,
        };
  
        dispatch(props.actionFunc({ filter: currentFilter }));
      } else {
       
        let currentFilter = {
          ...props.filter,
          
        };
        delete currentFilter["StartDate"]
        delete currentFilter["EndDate"]
  
        dispatch(props.actionFunc({ filter: currentFilter }));
      }
    }
  };
  

  const handleCustomDateChange = (range: [dayjs.Dayjs, dayjs.Dayjs]) => {
    let currentFilter={...props.filter}
    if(range)
    {
      const [startDate, endDate] = range;
      currentFilter["StartDate"] = startDate.format("YYYY-MM-DD")
      currentFilter["EndDate"] = endDate.format("YYYY-MM-DD")

    }
    else{
      delete currentFilter["StartDate"] 
      delete currentFilter["EndDate"] 
    }
    
    dispatch(props.actionFunc({ filter:currentFilter }));
  };


  const orderDateRange = [
    props.filter.OrderDateMin ? dayjs(props.filter.OrderDateMin) : undefined,
    props.filter.OrderDateMax ? dayjs(props.filter.OrderDateMax) : undefined,
  ].filter(Boolean) as dayjs.Dayjs[];

  return (
    <Col xs={props.xs} md={props.md} lg={props.lg} xl={props.xl} className={props.className}>
      <Row>
        {
          isShowCustomDate?<>
           <MazakaRangePicker
           label={props.isMobile?"Tarih":""}
            className="!m-0"
            size={props.size}
            name={"customDate"}
            onChange={handleCustomDateChange}
            span={24}
            value={orderDateRange||undefined}
          />
          <div>
            <Text onClick={()=>{
              setIsShowCustomDate(false)
              props.form.resetFields(["date"])
            }} className="!text-xs !text-blue-500 cursor-pointer" >Tarih Opsiyonları Göster</Text>
          </div>
          </>:<>
          
          <MazakaSelect
            span={24}
            name="date"
            label={props.isMobile?"Tarih":""}
            allowClear
            className="!w-full"
            size={props.size}
            onChange={handleDateFilterChange}
            value={selectedDateOption}
            options={Object.entries(dateOptions).map(([key, option]) => ({
              key,
              value: option.value,
              label: option.label,
            }))}
            placeholder="Tarih Seçin"
          />
          </>
        }
       
      </Row>
    </Col>
  );
};

export default GeneralTimePeriodsSelect;
